const env = {
    env: process.env.REACT_APP_ENV,
    app: {
        service_name: process.env.REACT_APP_SERVICE_NAME,
        port: 3000
    },
    logging: {
        key: process.env.REACT_APP_FRONTEND_LOGGING_KEY,
        endpoint: process.env.REACT_APP_FRONTEND_LOGGING_ENDPOINT
    },
    api_key: process.env.REACT_APP_API_KEY,
    urls: {
      email_url: process.env.REACT_APP_EMAIL_URL,
      account_url: process.env.REACT_APP_ACCOUNT_URL
    }
};

module.exports = env;